// 疑似スライド表示
export const PROFFIT_SEARCH_SEARCH_IS_SHOW_SIMILAR_SLIDES = [
    { label: '表示する', value: 'on' },
    { label: '表示しない', value: 'off' },
];
// ソート順
export const PROFFIT_SEARCH_SEARCH_SORTS = [
    { label: 'キーワードヒット順', value: 'keyword' },
    { label: '新着順', value: 'newer' },
    // TODO: リリースから暫くは一時的に非表示にする
    // { value: 'text_count_big', label: '文字が多い順' },
    // { value: 'text_count_small', label: '文字が少ない順' },
];
// 表示単位
export const PROFFIT_SEARCH_SEARCH_UNIT_SLIDE = {
    label: 'スライド単位',
    value: 'slide',
};
export const PROFFIT_SEARCH_SEARCH_UNIT_FILE = {
    label: 'ファイル単位',
    value: 'file',
};
export const PROFFIT_SEARCH_SEARCH_UNITS = [
    PROFFIT_SEARCH_SEARCH_UNIT_SLIDE,
    PROFFIT_SEARCH_SEARCH_UNIT_FILE,
];
